import { render, staticRenderFns } from "./VircosData.vue?vue&type=template&id=c505d966&scoped=true&"
import script from "./VircosData.vue?vue&type=script&lang=js&"
export * from "./VircosData.vue?vue&type=script&lang=js&"
import style0 from "./VircosData.vue?vue&type=style&index=0&id=c505d966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c505d966",
  null
  
)

export default component.exports